import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalName } from "src/app/enums/modal-name";
import { StorageKey } from "src/app/enums/storage-key";
import { IPaymentLink } from "src/app/models/client/payment-link";
import { ClientService } from "src/app/services/client.service";
import { ModalService } from "src/app/services/modal.service";
import { LocalStorage } from "src/libs/storage/src";

@Component({
  selector: "app-in-app",
  templateUrl: "./in-app.component.html",
  styleUrls: ["./in-app.component.scss"],
})
export class InAppComponent implements OnInit {
  constructor(
    private readonly _clientService: ClientService,
    private readonly _modalService: ModalService,
    private readonly _localStorage: LocalStorage,
    private readonly _router: Router
  ) {}

  openBuyClientNumberModal() {
    this._clientService.getClientFlags().subscribe(clientFlags => {
      if (clientFlags.hasProfileInfo) {
        this._modalService.openModal(ModalName.BuyClientNumber);
        return;
      }

      // Profile info must be filled before the free fax number is issued
      this._localStorage.setItem(StorageKey.IsPendingFaxNumberAfterProfile, "true");
      this._router.navigate(["/settings/profile"], { queryParams: { fillProfile: "true" } });
    });
  }

  onBuyClientNumberModalClose() {
    if (this._router.url.startsWith("/faxes/send")) {
      this._router.navigate(["/"]);
    }
  }

  createAndOpenClientNumberPaymentLink(paymentLink: IPaymentLink | null) {
    if (!paymentLink) {
      this._localStorage.setItem(StorageKey.IsPendingFaxNumberPurchase, "true");
      this._router.navigate(["/settings/profile"], { queryParams: { payment: "success" } });
      return;
    }

    this._localStorage.setItem(StorageKey.IsPendingFaxNumberPurchase, "true");
    window.open(paymentLink.url, "_blank", "noreferrer");
  }

  ngOnInit() {
    this.openFaxPhoneNumberModalIfNeeded();
  }

  private openFaxPhoneNumberModalIfNeeded() {
    return this._clientService.getClientFlags().subscribe(clientFlags => {
      if (!clientFlags.hasSubscription || clientFlags.hasFaxPhoneNumber) {
        return;
      }

      const hasSeenTrialSubscriptionModal =
        this._localStorage.getItem(StorageKey.HasSeenTrialSubscriptionModal) === "true";

      if (hasSeenTrialSubscriptionModal) {
        this._modalService.openModal(ModalName.MissingSubscriptionError);
      } else {
        this._modalService.openModal(ModalName.TrialSubscription);
      }
    });
  }
}
